<template>
  <section class="hero">
    <div class="hero-inner container">
      <div class="hero-text">
        <h1>
          WHERE WE<br class="show-br-mobile"/> STARTED </h1>
        <p class="mb-2rem">
          In 2016, the American Society for Dermatologic Surgery Association (ASDSA) launched a response to schools
          prohibiting sunscreen due to its classification as an over-the-counter medication. </p>
        <p class="mb-2rem">
          The <strong><a class="text-link"
                         href="https://gbr01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.asds.net%2Fasdsa-advocacy%2Fadvocacy-activities%2Fsunucate-coalition&data=04%7C01%7CJay.Syzdek%40wearelucidgroup.com%7C9daf3f5bfbd2436bc01108d9d539f053%7C4a3cfba2a76b4b2eac1da2e88b44c1c2%7C0%7C0%7C637775267078656661%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000&sdata=cfmmtCE672at35ToU6rXl8AruvD9J%2F2NolBMe%2BkUUn4%3D&reserved=0"
                         target="_blank">SUNucate</a> model legislation</strong> was developed and passed to ensure
          children have access to sunscreen and sun-protective clothing in schools and camps. To date, 26 states and
          Washington, DC, have adopted SUNucate protections. </p>
      </div>
      <div class="sun-hero-image">
        <!-- <img src="@/assets/images/global/Super-Sam-SunHero-300-V1.svg" alt="" /> -->
        <SuperSamSunHero/>
      </div>
    </div>
  </section>
</template>
<script>
import SuperSamSunHero from './svg/SuperSamSunHero.vue'

export default {
  components: {
    SuperSamSunHero,
  },
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";

section {
  overflow: unset;
}

.text-link {
  color: @color-orange;
  text-decoration: underline;
}

.hero {
  position: relative;
  background-image: url("~@/assets/images/global/burst-left.png");
  background-size: auto 100%;
  background-position: left center;
  background-repeat: no-repeat;
  height: 51rem;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    background-image: none;
    height: auto;
  }

  & > div {
    z-index: 12;
  }

  &:before {
    background-image: url("~@/assets/images/global/burst-right.png");
    background-size: auto 100%;
    background-position: right center;
    background-repeat: no-repeat;
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      background-image: none;
    }
  }

  .sun-hero-image {
    width: 524px;
    position: absolute;
    top: 9%;
    left: 67%;

    img {
      width: 100%;
      object-fit: cover;
    }

    @media screen and (max-width: 1300px) {
      // transform: scale(1.4);
    }
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      display: none;
    }
  }

  .hero-inner {
    display: flex;
    flex-flow: row;
    align-content: space-around;
    padding-top: .clampedW(8, @md-bp, @large-bp) [ @result];
    @media screen and (max-width: ~"@{mq-xs-bp}") {
      // padding-bottom: 12rem;
    }

    .hero-text {
      margin-top: 8rem;
      @media screen and (max-width: 1000px) {
        margin-top: 7.5rem;
        max-width: 47rem;
      }
      @media screen and (max-width: 768px) {
        width: 100%;
        max-width: unset;
      }

      .hero-callout {
        color: @color-dk-orange;
        font-weight: 700;
        text-decoration: underline;
      }

      .mb-2rem {
        margin-bottom: 2rem;
      }
    }

    h1 {
      font-size: 6.25em;
      text-align: left;
      @media screen and (max-width: ~"@{mq-md-bp}em") {
        font-size: 5em;
        text-align: center;
        // margin-top: 1.1em;
      }
    }

    h1,
    div,
    p {
      // flex: 0 1 100%;
    }

    p {
      // font-size: .clampedW(4, @md-bp, @large-bp) [ @result];
      font-size: 18px;
      // padding-right: .clampedW(15, @md-bp, @large-bp) [ @result];
      line-height: 2.5rem;
      @media screen and (min-width: 1000px) {
        font-size: .clampedW(3, @md-bp, @large-bp) [ @result] !important;
        max-width: 57rem;
        // padding-right: .clampedW(8, @md-bp, @large-bp) [ @result];
      }
      @media screen and (max-width: ~"@{mq-xs-bp}") {
        // font-size: .clampedW(4.5, @md-bp, @large-bp) [ @result];
        padding-right: 0;
        line-height: 2.5rem;
      }

      &.footnote {
        font-size: .clampedW(2, @md-bp, @large-bp) [ @result];
        line-height: 1.2;
        // padding: 0 25%;
      }
    }
  }
}
</style>
